import { useHistory } from 'react-router-dom';
import { bool, func } from 'prop-types';

import SubscriptionPopup from '~/components/SubscriptionPopup/index';

import { SEASON_TICKET_PATH } from '~/routes/paths';

export default function SubscriptionRedirectPopup({ show, onClose }) {
  const history = useHistory();
  const onCLick = () => history.push(SEASON_TICKET_PATH);
  return (
    <SubscriptionPopup
      show={show}
      onClose={onClose}
      description="season_ticket_popup_lootpack_description"
      onClick={onCLick}
      buttonText="season_ticket_popup_lootpack_button"
      header="season_ticket_popup_lootpack_headline"
    />
  );
}

SubscriptionRedirectPopup.propTypes = {
  show: bool.isRequired,
  onClose: func.isRequired,
};
